import { isEmpty } from 'lodash';
import { Location } from '@dealersites/location-widget';

const TTL_MS = 24 * 60 * 60 * 1000; // 24 hours

export const LocationStorage = new (class {
  get #storageKey() {
    return '@oc:last_location';
  }

  get() {
    const stored = JSON.parse(localStorage.getItem(this.#storageKey) ?? '{}');
    if (isEmpty(stored)) return undefined;

    const age = Date.now() - (stored.savedAt ?? 0);
    if (age > TTL_MS) {
      this.clear();
      return undefined;
    }

    return !isEmpty(stored.location) ? Location.fromJSON(stored.location) : undefined;
  }

  set(location) {
    localStorage.setItem(
      this.#storageKey,
      JSON.stringify({ location: location?.storageValue ?? {}, savedAt: Date.now() }),
    );

    // Write coordinates to a cookie so PHP can read them server-side on the next
    // page load and render location-aware inventory without any client API calls.
    const coordinates = location?.coordinates?.searchValue() ?? '';
    if (coordinates) {
      document.cookie = `oc_location=${encodeURIComponent(coordinates)}; path=/; max-age=${60 * 60 * 24}; SameSite=Lax`;
    } else {
      document.cookie = 'oc_location=; path=/; max-age=0; SameSite=Lax';
    }
  }

  clear() {
    localStorage.removeItem(this.#storageKey);
    document.cookie = 'oc_location=; path=/; max-age=0; SameSite=Lax';
  }
})();
